import { ObjectSchema, StringSchema, array, boolean, mixed, number, object, string } from 'yup';
import validator from 'validator';
import { TrendGraphView } from '../../models/trend-graph-view';

export const MAX_TREND_GRAPHS = 50;
export const TREND_GRAPH_MAX_CHANNELS = 16;
export const TREND_GRAPH_MAX_TRANSLATIONS = 200;

export function trendGraphViewValidator(): ObjectSchema<TrendGraphView> {
    return object({
        id: string().optional(),
        name: string().trim().required().nonNullable().max(32),
        description: string(),
        channels: array()
            .ensure()
            .max(TREND_GRAPH_MAX_CHANNELS)
            .of(
                object({
                    fcuChannelId: number().integer().required().nonNullable(),
                    color: string()
                        .required()
                        .nonNullable()
                        .test((v) => validator.isHexColor(v)),
                })
                    .required()
                    .nonNullable()
                    .noUnknown()
                    .strict(),
            )
            .required(),
        publicAccess: boolean().required().nonNullable(),

    })
        .noUnknown()
        .strict() as ObjectSchema<TrendGraphView>; //Type casted because there's a bug with required types in arrays
}
